<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add News

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="modal-body padding-top-0px">








          <div class="margin-left-zero p-0 margin-top-20px">
            <!--<div class="row">
              <div class="col-md-3">
                <h4 class="heading-pinkbg mt-0">New Patient</h4>
              </div>
              <div class="col-md-9 margin-top-10">

                <button type="submit" *ngIf='!isRequesting' (click)="gotoprofile()" class="btn actions-btn-prime nav-link-hand float-right margin-right-10px">Save</button>
                <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right">Cancel</button>
              </div>
            </div>-->
            <div class="row my-profile-form margin-top-form">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 text-align-right">
                    <label for="firstName" class="label-size"><span>*</span> Name </label>
                  </div>
                  <div class="col-md-3">

                    <input type="text" class="form-control" id="CurrentSaveNewsRequest.Name"
                           [(ngModel)]="CurrentSaveNewsRequest.Name" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentSaveNewsRequest.Name" placeholder="Name" required maxlength="100" minlength="1" #Name="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!Name.valid && (Name.dirty || Name.touched) && Name.errors.required)">(Field cannot be left blank)</small>

                    <small class="form-text text-danger"
                           *ngIf="(!Name.valid && Name.errors.pattern)">(special characters are not allowed)</small>

                  </div>
                 
                </div>

              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 text-align-right">
                    <label for="birthDate" class="label-size"><span>*</span> Created At  </label>
                  </div>
                  <div class="col-md-3">
                    <div class="date-form">
                      <input class="form-control form-control-patient" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="CreatedAt" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel">
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>


                </div>
              </div>

            </div>
            <div class="row my-profile-form">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 text-align-right">
                    <label for="diaplayName" class="label-size"><span>*</span> Category </label>
                  </div>

                  <div class="col-md-3">
                    <!--<CodeTypeValue CodeType="Sex"
    id="CurrentActorPersonalDetailInfoRequest.MaritalStatus"
    [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.MaritalStatus}}"
    name="CurrentActorPersonalDetailInfoRequest.MaritalStatus">
  </CodeTypeValue>-->
                    <input type="text" class="form-control" id="CurrentSaveNewsRequest.Category"
                           [(ngModel)]="CurrentSaveNewsRequest.Category" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentSaveNewsRequest.Category" placeholder="Category" required maxlength="100" minlength="1" #Category="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!Category.valid && (Category.dirty || Category.touched) && Category.errors.required)">(Field cannot be left blank)</small>

                    <small class="form-text text-danger"
                           *ngIf="(!Category.valid && Category.errors.pattern)">(special characters are not allowed)</small>

                  </div>
                </div>


              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 text-align-right">
                    <label for="diaplayName" class="label-size"><span>*</span> Posted By </label>
                  </div>
                  <div class="col-md-3">
                    <input type="text" class="form-control" id="CurrentSaveNewsRequest.PostedBy"
                           [(ngModel)]="CurrentSaveNewsRequest.PostedBy" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentSaveNewsRequest.PostedBy" placeholder="Posted By" required maxlength="100" minlength="1" #PostedBy="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!PostedBy.valid && (PostedBy.dirty || PostedBy.touched) && PostedBy.errors.required)">(Field cannot be left blank)</small>

                    <small class="form-text text-danger"
                           *ngIf="(!PostedBy.valid && PostedBy.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                </div>


              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">

                  <div class="col-md-3 text-align-right">
                    <label for="email address" class="label-size"><span>*</span> Published In  </label>
                  </div>
                  <div class="col-md-3">
                    <input type="text" class="form-control" id="CurrentSaveNewsRequest.PublishedIn"
                           [(ngModel)]="CurrentSaveNewsRequest.PublishedIn" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentSaveNewsRequest.PublishedIn" placeholder="Published In" required maxlength="100" minlength="1" #PublishedIn="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!PublishedIn.valid && (PublishedIn.dirty || PublishedIn.touched) && PublishedIn.errors.required)">(Field cannot be left blank)</small>

                    <small class="form-text text-danger"
                           *ngIf="(!PublishedIn.valid && PublishedIn.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 text-align-right">
                    <label for="diaplayName" class="label-size">Presented In</label>
                  </div>
                  <div class="col-md-3">
                    <input type="text" class="form-control" id="CurrentSaveNewsRequest.PresentedIn"
                           [(ngModel)]="CurrentSaveNewsRequest.PresentedIn" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentSaveNewsRequest.PresentedIn" placeholder="Presented In" required maxlength="100" minlength="1" #PresentedIn="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!PresentedIn.valid && (PresentedIn.dirty || PresentedIn.touched) && PresentedIn.errors.required)">(Field cannot be left blank)</small>

                    <small class="form-text text-danger"
                           *ngIf="(!PresentedIn.valid && PresentedIn.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                </div>


              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 text-align-right">
                    <label for="diaplayName" class="label-size"><span>*</span> URL </label>
                  </div>
                  <div class="col-md-3">
                    <input type="text" class="form-control" id="CurrentSaveNewsRequest.URL"
                           [(ngModel)]="CurrentSaveNewsRequest.URL" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentSaveNewsRequest.URL" placeholder="URL" required maxlength="100" minlength="1" #URL="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!URL.valid && (URL.dirty || URL.touched) && URL.errors.required)">(Field cannot be left blank)</small>

                    <small class="form-text text-danger"
                           *ngIf="(!URL.valid && URL.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                </div>


              </div>
            </div>

            <!--<div class="row my-profile-form">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 text-align-right">
                    <label for="diaplayName" class="label-size"><span>*</span> CreatedBy </label>
                  </div>
                  <div class="col-md-3">
                    <input type="text" class="form-control" id="CurrentSaveNewsRequest.CreatedBy"
                           [(ngModel)]="CurrentSaveNewsRequest.CreatedBy" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                           name="CurrentSaveNewsRequest.CreatedBy" placeholder="Created By" required maxlength="100" minlength="1" #CreatedBy="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!CreatedBy.valid && (CreatedBy.dirty || CreatedBy.touched) && CreatedBy.errors.required)">(Field cannot be left blank)</small>

                    <small class="form-text text-danger"
                           *ngIf="(!CreatedBy.valid && CreatedBy.errors.pattern)">(special characters are not allowed)</small>
                  </div>
                </div>


              </div>
            </div>-->
            
            <!--<div class="row margin-bottom-10px">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 text-align-right offset-md-1">
                    <label for="diaplayName"><span>*</span> Physician</label>
                  </div>

                  <div class="col-md-3">
                    <CodeTypeValue CodeType="Sex">

                    </CodeTypeValue>

                  </div>
                </div>


              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 offset-md-1 text-align-right">
                    <label for="diaplayName"> Description</label>
                  </div>

                  <div class="col-md-4">
                    <textarea class="form-control2" rows="2" placeholder="Description"></textarea>

                  </div>
                </div>


              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-3 offset-md-1 text-align-right">
                    <label for="diaplayName"> Recommendations</label>
                  </div>

                  <div class="col-md-4">
                    <textarea class="form-control2" rows="2" placeholder="Recommendations"></textarea>

                  </div>
                </div>


              </div>
            </div>-->
            <div class="row pl-3 pr-3 margin-left-zero margin-left-zero">


              <!--<div class="form-group col-md-6 col-xs-12">
                <label for="eventInput1"><span>*</span> Physician</label>
                <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorMedicalFitness" id="CurrentActorMedicalFitnessRequest.CredentialTypeCode"
                                         [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialTypeCode" name="CurrentActorMedicalFitnessRequest.CredentialTypeCode" required
                                         (keyChange)="onCredentialTypeByGroup($event)" #CredentialTypeCode="ngModel">
                </CustomDataByRequestType>
                <small class="form-text text-danger"
                       *ngIf="(!CredentialTypeCode.valid && (CredentialTypeCode.dirty || CredentialTypeCode.touched) && CredentialTypeCode.errors.required )">(Field cannot be left blank)</small>


              </div>-->
              <!--<div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2">Certificate Number</label>
                <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.CredentialNumber" [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialNumber" name="CurrentActorMedicalFitnessRequest.CredentialNumber" placeholder="CredentialNumber">
              </div>-->
              <!--<div class="form-group col-md-6 col-xs-12">
                <label for="eventInput4">Description</label>





              </div>-->
              <!--<div class="form-group col-md-6 col-xs-12">
                <label for="eventInput5">Recommendations</label>

              </div>-->


              <br /><br /><br />  <br /><br /><br />  <br />

            </div>
          </div>
          <!--<div class="row">
            <div class="card-footer text-right col-12">


            </div>
          </div>-->















        </div>




        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
          <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>
